// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-bar-page{background-color:#fff;width:962px;min-height:862px}.status-bar-page .pointer span{transition:.2s}@media (min-width:1024px){.status-bar-page .pointer:hover span{color:#e50b09}}@media (max-width:1550px){.status-bar-page{width:770px}}@media (max-width:1440px){.status-bar-page{width:621px}}@media (max-width:1439px){.status-bar-page{width:714px}}@media (max-width:1365px){.status-bar-page{width:100%}}@media (max-width:1023px){.status-bar-page{min-height:0}}", ""]);
// Exports
module.exports = exports;
